
const appSyncConfig = {
  aws_appsync_graphqlEndpoint: "https://m5gxckh7mfdllogqompq5i4oze.appsync-api.ap-south-1.amazonaws.com/graphql",
  aws_appsync_region: "ap-south-1",
  aws_appsync_authenticationType: "API_KEY",
  aws_appsync_apiKey: "da2-dkegsbhe5nayplv5nsln5e34re", 
};

export default appSyncConfig;
